import { useEffect, useRef, useState } from "react"
import CallToAction from "components/CallToAction"
import Image from "components/Image"
import Modal from "components/Modal"
import AlertBanner from "components/DynamicComponent/atoms/AlertBanner"
import Phone from "public/assets/rotate-phone.svg"
import useModal from "utilities/useModal"
import getStoryblokLink from "utilities/getStoryblokLink"
import richText from "utilities/richText"

function HelpModal({ content }) {
  const modalProps = useModal("webcam-help-modal")

  return (
    <Modal {...modalProps}>
      <div className="prose-h2:text-center prose-h2:pb-4 prose-h3:text-m1 prose-h3:pb-2 prose-h3:leading-7 prose-p:pb-2 prose-a:text-green-pine">
        {richText(content)}
      </div>
    </Modal>
  )
}

export default function WebcamEmbed({ blok }) {
  const [agreement, setAgreement] = useState("pre-agreement")
  const webcamRef = useRef(null)

  useEffect(() => {
    if (agreement === "agree") webcamRef.current.focus()
  }, [agreement])

  return (
    <>
      {agreement === "agree" ? <HelpModal content={blok.webcam_help} /> : null}
      {blok.webcam_down ? (
        <AlertBanner
          blok={{
            color_variation: "green-teal",
            content: {
              type: "doc",
              content: [
                {
                  type: "paragraph",
                  content: [
                    {
                      text: "Our webcams are currently down. We are working hard to get them back up as soon as possible. Please check back later.",
                      type: "text",
                    },
                  ],
                },
              ],
            },
          }}
        />
      ) : null}
      <section className="px-8 py-12">
        <div className="max-w-screen-xl w-full h-full mx-auto">
          {agreement === "agree" ? (
            <>
              {blok.iframe !== null || blok.iframe !== undefined ? (
                <iframe
                  ref={webcamRef}
                  allow="fullscreen"
                  className="max-w-full h-72 sm:h-auto sm:aspect-video mx-auto pb-4"
                  src={getStoryblokLink(blok.iframe)}
                  width="1033"
                  title={blok.title ? blok.title : ""}
                />
              ) : null}
              <div className="sm:hidden bg-green-pine text-white flex items-center gap-4 p-3 font-medium">
                <Phone className="w-11 h-10" />
                For best results, rotate your device and enable fullscreen.
              </div>
              <div className="lg:flex gap-4 justify-center items-center pt-8">
                <h2 className="text-center mb-4 lg:mb-0 text-l1 lg:text-l2 leading-8 lg:leading-10">
                  Having issues with the feed?
                </h2>
                <CallToAction href="#webcam-help-modal" style="secondary" className="table mx-auto lg:mx-0">
                  Webcam help
                </CallToAction>
              </div>
            </>
          ) : (
            <div className="w-[1033px] max-w-full sm:aspect-video rounded-3xl bg-gray-light mx-auto">
              {agreement === "pre-agreement" ? (
                <div tabIndex={0} className="modal  w-full max-w-screen-lg p-8">
                  <div className="lg:block w-full py-12 md:px-6 prose-h2:text-center prose-h2:pb-4 prose-p:pb-4 prose-a:text-green-pine">
                    {richText(blok.terms_of_use)}
                    <div className="flex flex-wrap  sm:flex-row gap-4 justify-center items-start">
                      <CallToAction onClick={() => setAgreement("agree")} button>
                        I Agree
                      </CallToAction>
                      <CallToAction onClick={() => setAgreement("disagree")} style="secondary" button>
                        I Disagree
                      </CallToAction>
                    </div>
                  </div>
                </div>
              ) : null}
              {agreement === "disagree" ? (
                <div className="flex flex-col sm:flex-row gap-6 lg:gap-12 max-w-4xl mx-auto h-full items-center px-6 py-12">
                  <Image
                    loader={undefined}
                    src={"/assets/pets/border-collie.png"}
                    alt="border-collie"
                    width={200}
                    height={350}
                    className="object-contain basis-1/2 sm:basis-1/4"
                  />
                  <div className="basis-1/2 sm:basis-3/4">
                    <h2 className="pb-4">Bad human, no webcams!</h2>
                    <p className="pb-4">You must agree to the Terms of Use. </p>
                    <CallToAction
                      onClick={() => setAgreement("pre-agreement")}
                      className="underline hover:no-underline"
                      button
                    >
                      Read Terms of Use
                    </CallToAction>
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </section>
    </>
  )
}
